import React from 'react';

export interface DecisionTreeState {
  isMounted: boolean;
  setIsMounted: (value: boolean) => void;
  runId: string | null;
  setRunId: (value: string | null) => void;
  nodeHistory: string[];
  setNodeHistory: (value: string[]) => void;
}

export default function useDecisionTree(): DecisionTreeState {
  const [isMounted, setIsMounted] = React.useState(false);
  const [runId, setRunId] = React.useState<string | null>(null);
  const [nodeHistory, setNodeHistory] = React.useState<string[]>([]);

  return {
    isMounted,
    setIsMounted,
    runId,
    setRunId(value: string | null) {
      setNodeHistory([]);
      setRunId(value);
    },
    nodeHistory,
    setNodeHistory,
  };
}
